module.exports = __webpack_public_path__ + "static/media/events-second.388228ba.jpg";